import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation-simplify',
  templateUrl: './confirmation-simplify.component.html',
  styleUrls: ['./confirmation-simplify.component.css']
})
export class ConfirmationSimplifyComponent {

  status: any = null;

  constructor(private router: Router) { }
  ngOnInit(): void {
    this.status = sessionStorage.getItem('canSuccess');

    if (this.status == undefined) {
      this.router.navigate(['/']);
    }
  }

}
